export enum SessionServiceErrorType {
	INVALID_ACCESS_TOKEN_ERROR = 'InvalidAccessTokenError',
	INVALID_REFRESH_TOKEN_ERROR = 'InvalidRefreshTokenError',
	REFRESH_TOKEN_ERROR = 'RefreshTokenError',
	LOGOUT_ERROR = 'LogoutError',
	SESSION_NOT_FOUND_ERROR = 'SessionNotFoundError',
}
